import '.gt{border-radius:0.625rem 0 0 0.625rem;}.ssr-plugin'
import '.gu{border-block:var(--gray-border);}.ssr-plugin'
import '.gv{border-left:var(--gray-border);}.ssr-plugin'
import '.gw{border-right:0px;}.ssr-plugin'
import '.bb{padding:0px;}.ssr-plugin'
import '.ar{cursor:pointer;}.ssr-plugin'
import '.bi{background:none;}.ssr-plugin'
import '.gx{border-radius:0 0.625rem 0.625rem 0;}.ssr-plugin'
import '.gy{border-right:var(--gray-border);}.ssr-plugin'
import '.gz{border-left:0px;}.ssr-plugin'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style, styled } from 'inlines'

export type AmountPickerProps = {
  label: string
  value: number
  setValue: React.Dispatch<React.SetStateAction<number>>
  min?: number
  max?: number
}

const commonStyles: Style = {
  width: '2.6875rem',
  height: '2.6875rem',
  display: 'flex',
  flex: '1',
  justifyContent: 'center',
  alignItems: 'center',
}

export const AmountPicker = ({
  value,
  label,
  min = 0,
  max = 10,
  setValue,
}: AmountPickerProps) => {
  const decrease = () => {
    if (value > min) {
      setValue((prev) => prev - 1)
    }
  }
  const increase = () => {
    if (value < max) {
      setValue((prev) => prev + 1)
    }
  }
  return (
    <Column gap={0}>
      <Text.Medium
        color="var(--shades-blue-500)"
        style={{ height: '2.125rem' }}
      >
        {label}
      </Text.Medium>
      <Row style={{ width: '8.0625rem' }} gap={0}>
        <styled.button className="gt gu gv gw bb ar bi"
          onClick={decrease}
          style={{
            ...commonStyles,}}
        >
          <FontAwesomeIcon icon={faMinus} />
        </styled.button>
        <Text.Medium
          style={{
            ...commonStyles,
            border: 'var(--gray-border)',
            userSelect: 'none',
          }}
        >
          {value}
        </Text.Medium>
        <styled.button className="gx gu gy gz bb ar bi"
          onClick={increase}
          style={{
            ...commonStyles,}}
        >
          <FontAwesomeIcon icon={faPlus} />
        </styled.button>
      </Row>
    </Column>
  )
}
